import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

interface BreadcrumbProps {
  items: { label: string; to?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const categoryMap = Object.fromEntries(
    categories.map((c) => [c.slug, c.name])
  );

  return (
    <nav aria-label="Breadcrumb" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        <li>
          <Link
            to="/"
            className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
          >
            首页
          </Link>
        </li>
        {items.map((item, idx) => {
          const label = categoryMap[item.label] || item.label;
          return (
            <li key={idx} className="flex items-center gap-1">
              <span className="text-foreground-400 mx-1">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
              {item.to ? (
                <Link
                  to={item.to}
                  className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium">{label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}